import { connect } from 'react-redux';
import TerminalLogin from './TerminalLogin';
import { mapStateToProps, mapDispatchToProps } from './TerminalLogin.state';

export default connect(mapStateToProps, mapDispatchToProps)(TerminalLogin);
